import { ControlType, Field, Section } from "@cotecna/dynamic-view-engine";
import { environment } from "src/environments/environment";

export const IMPORT_ITEMS_FIELDS: Field[] = [
  {
    id: "formId",
    type: ControlType.Dropdown,
    label: "Form",
    order: 1,
    propertyName: "form",
    value: null,
    required: true,
    visible: true,
    valid: true,
  },
];

export const IMPORT_ITEMS_SECTIONS: Section[] = [
  {
    id: "1",
    name: "",
    order: 1,
    isFixed: true,
    fields: IMPORT_ITEMS_FIELDS,
    actions: [],
  },
];

export const IMPORT_ITEMS_CONTROLS: any[] = [
  {
    id: "formId",
    options: [],
  },
];
